import './rackDetails.css'
import x from './Vector (1).svg'
import downloadImg from './File download.svg';
import DownloadSpreadseheet from '../../utils/DonwloadSpreadsheet';

function RackDetails(props) {

    function addView(id, index, data) {
        let div = document.getElementById(id)
        if (div.classList.contains(`expand-circuits`)) {
            if (index + 1 === data.length) {
                div.classList.remove(`invert-order-chart`)
            }
            div.classList.remove(`expand-circuits`)
        } else {
            if (index + 1 === data.length) {
                div.classList.add(`invert-order-chart`)
            }
            div.classList.add(`expand-circuits`)
        }
    }

    return (
        <section className='modal-rack-details'>
            <div className='content-modal-racks'>
                <img onClick={() => props.close()} src={x} alt='x' />
                <div className='content-modal-racks-header'>
                    <h1>{props.data.client.client}</h1>
                    <div className='content-modal-racks-btn-download'>
                        <button onClick={() => (DownloadSpreadseheet(props.data.client.client, props.data.sites))}>
                            <img src={downloadImg} alt="Ícone decorativo pdo botão de donwload."/>
                            <p>Export</p>
                        </button>
                    </div>
                </div>
                {
                    props.data.sites.map(site => {
                        return (
                            <div className='content-modal-racks-table'>
                                <h2>{site.siteName}</h2>
                                {
                                    site.racks.map((value, index) => {
                                        return (
                                            <div className='content-racks-table-modal'>
                                                <h4>Scala Rack Name: {value.nscala}</h4>
                                                <table className='table-estructure-rack_table-modal'>
                                                    <thead>
                                                        <tr>
                                                            <th>DH</th>
                                                            <th>Status</th>
                                                            <th>Cages</th>
                                                            <th>Created</th>
                                                            <th>Client Rack Name</th>
                                                            <th>Row - Y axis</th>
                                                            <th>Position - X axis</th>
                                                            <th>Occuppation</th>
                                                            <th>Power</th>
                                                            <th>Classif.</th>
                                                            <th>PDU / Circuit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{value.room.room}</td>
                                                            <td>{value.status ? 'Added' : 'Churned'}</td>
                                                            <td>{value.cage?.name ? value.cage.name : 'No Cage'}</td>
                                                            <td>{new Date(value.createdAt).toLocaleDateString()}</td>
                                                            <td>{value?.nrack}</td>
                                                            <td>{value?.fileira}</td>
                                                            <td>{value?.posicao}</td>
                                                            <td>{value?.ocupacao}</td>
                                                            <td>{value?.potenciaContratada}</td>
                                                            <td>{value?.classification == null ? 'N/A': value?.classification}</td>
                                                            <td>
                                                                {
                                                                    value.pduRacks.length > 0 ?
                                                                        <div className='content-circuit'>
                                                                            {value.pduRacks.map((val, i) => {
                                                                                if (i < 3) {
                                                                                    return (
                                                                                        <div className='card-content-circuit'>
                                                                                            <h2>{val.name} | {val.circuito}</h2>
                                                                                        </div>
                                                                                    )
                                                                                } else {
                                                                                    return null
                                                                                }
                                                                            })}
                                                                            <div onMouseEnter={() => addView(`popup-${index}`, index, value.pduRacks)} onMouseLeave={() => addView(`popup-${index}`, index, value.pduRacks)} style={{ display: value.pduRacks.length > 3 ? 'flex' : 'none' }} className='plus-content-circuit'>
                                                                                <h3>+{value.pduRacks.length - 3}</h3>
                                                                                <div id={`popup-${index}`} className='pop-up-circuits'>
                                                                                    <div className='triangle'></div>
                                                                                    {value.pduRacks.map((val, i) => {
                                                                                        if (i > 2) {
                                                                                            return (
                                                                                                <div className='card-content-circuit popup-card' key={i}>
                                                                                                    <h2>{val.name} | {val.circuito}</h2>
                                                                                                </div>
                                                                                            )
                                                                                        } else {
                                                                                            return null
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        'No PDUs'
                                                                }
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default RackDetails